<template lang="pug">
    section
        el-row.no-padding(:gutter="20")
            el-col(:lg="6" :md="14")
                .generate-switch(v-if="isNewCustomer")
                    el-form-item.switch(size="mini" label="")
                        el-switch(
                            :active-text="$t('Generate the customer ID automatically')"
                            inactive-color="#ff4949"
                            v-model="autoCustomerNr"
                        )
                transition(name="slide-decent-vertical")
                    .customer-id-flex-col(v-if="!isNewCustomer || !autoCustomerNr")
                        el-form-item.input(:label="$t('Customer ID')" prop="customer.nr")
                            el-input(
                                :disabled="isNewCustomer && autoCustomerNr"
                                v-model="customerNr"
                                ref="customerNr"
                            )
                el-form-item(:label="$t('Customer group')" prop="customer.customerGroup")
                    el-select.is-full-width(
                        placeholder=""
                        v-model="customerGroup"
                        valueKey="id"
                    )
                        el-option(
                            v-for="item in options.customerGroup.items"
                            :key="item.id"
                            :label="item.name"
                            :value="item"
                        )
                template(v-if="netPriceFeatureEnabled")
                    .switch-row
                        el-switch(
                            :active-text="$t('Customer sees net prices')"
                            inactive-color="#ff4949"
                            v-model="showNetPrices"
                        )
                    .switch-row
                        el-switch(
                            :active-text="$t('Customer buys tax free')"
                            inactive-color="#ff4949"
                            v-model="taxFree"
                        )
                    .switch-row(v-if="enabledExtensions.includes('shop:point-of-sale')")
                        el-switch(
                            :active-text="$t('Customer can view point of sale purchases on his user page')"
                            inactive-color="#ff4949"
                            v-model="showPointOfSalePurchases"
                        )
            el-col(:lg="18" :md="10")
                .coupons(v-if="coupons && coupons.length")
                    Coupon(
                        v-for="coupon in coupons"
                        :key="coupon.id"
                        :data="coupon"
                        :customer="customer"
                        :customer-name="name"
                        :options="options"
                        @delete="deleteCoupon"
                        @unlink="markCouponAsDeleted"
                        @link="unmarkCouponAsDeleted"
                        @submit="updateCoupon"
                    )

                CouponForm(
                    v-if="pendingCoupon"
                    :key="pendingCoupon.id"
                    :data="pendingCoupon"
                    :customer="customer"
                    :visibility.sync="showCouponForm"
                    @submit="createCoupon"
                    @close="closeCouponForm"
                )

                el-button(type="primary" plain icon="el-icon-fa-plus fas" @click="addCoupon") {{ $t('Add Coupon') }}
</template>

<i18n>
{
    "de": {
        "Generate the customer ID automatically": "Kundennummer automatisch generieren",
        "Customer ID": "Kundennummer",
        "Customer group": "Kundengruppe",
        "Active": "Aktiv",
        "Inactive": "Inaktiv",
        "Blocked": "Gesperrt",
        "Customer sees net prices": "Kunde sieht Nettopreise",
        "Customer buys tax free": "Kunde kauft steuerfrei",
        "Customer can view point of sale purchases on his user page": "Kunde kann Kassenverkäufe auf seiner Benutzerseite einsehen",
        "Add Coupon": "Gutschein hinzufügen",
        "Add Discount": "Rabatt hinzufügen"
    }
}
</i18n>

<script>

import _ from 'lodash'
import uniqid from 'uniqid'
import { useSetupStore, useRestrictedAreaMemberStore } from '@/stores'

import Coupon from './Partials/Coupon'
import CouponForm from './Partials/CouponForm'

export default {
    name: 'Customer',
    data() {
        return {
            // generateCustomerID: undefined,
            pendingCoupon: undefined,
            showCouponForm: false,
        }
    },
    components: {
        Coupon,
        CouponForm
    },
    computed: {
        memberStore() {
            return useRestrictedAreaMemberStore()
        },
        // autoCustomerNr: {
        //     get() {
        //         if (this.generateCustomerID === undefined) return true
        //         else if (!this.customerNr) return false
        //         return this.generateCustomerID
        //     },
        //     set(value) {
        //         this.generateCustomerID = value
        //         if (!value) {
        //             this.$nextTick(() => {
        //                 const el = this.$refs.customerNr.$el
        //                 const input = el.getElementsByTagName('input');
        //                 if (input.length) input[0].select();
        //             })
        //         } else {
        //             this.customerNr = uniqid.time().toUpperCase()
        //         }
        //     }
        // },
        autoCustomerNr: {
            get() {
                return this.customerNr === undefined
            },
            set(value) {
                if (!value) {
                    // this.customerNr = uniqid.time().toUpperCase()
                    this.customerNr = '';
                    this.$nextTick(() => {
                        const el = this.$refs.customerNr.$el
                        const input = el.getElementsByTagName('input');
                        if (input.length) input[0].select();
                    })
                } else {
                    this.customerNr = undefined
                }
            }
        },
        isNewCustomer() {
            const id = _.get(this.form, 'customer.id')
            return !id || _.startsWith(id, 'new:')
        },
        name() {
            return `${_.get(this.form, 'first_name', '')} ${_.get(this.form, 'last_name', '')}`.trim()
        },
        customer() {
            let customer = _.cloneDeep(this.form.customer)
            customer.member = _.cloneDeep(this.form)
            delete customer.member.customer
            return customer
        },
        customerNr: {
            get() {
                return _.get(this.form, 'customer.nr')
            },
            set(value) {
                this.memberStore.setFormCustomerNr(value)
            }
        },
        customerGroup: {
            get() {
                return _.get(this.form, 'customer.customerGroup')
            },
            set(value) {
                this.memberStore.setFormCustomerGroup(value)
            }
        },
        showNetPrices: {
            get() {
                return this.taxFree || _.get(this.form, 'customer.show_net_prices', false)
            },
            set(value) {
                this.memberStore.setFormCustomerShowNetPrices(value)
                if (value === false) this.memberStore.setFormCustomerTaxFree(value)
            }
        },
        taxFree: {
            get() {
                return _.get(this.form, 'customer.tax_free', false)
            },
            set(value) {
                this.memberStore.setFormCustomerTaxFree(value)
                if (value === true) this.memberStore.setFormCustomerShowNetPrices(value)
            }
        },
        showPointOfSalePurchases: {
            get() {
                return _.get(this.form, 'customer.show_point_of_sale_purchases', false)
            },
            set(value) {
                this.memberStore.setFormCustomerShowPointOfSalePurchases(value)
            }
        },
        coupons() {
            return _.get(this.form, 'customer.coupons') || []
        },
        netPriceFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'customer-net-prices');
        },
        setupStore() {
            return useSetupStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions
        },
        form() {
            return this.memberStore.form
        },
        options() {
            return this.memberStore.options
        },
    },
    methods: {
        addCoupon() {
            this.pendingCoupon = {
                id: uniqid('new:'),
                name: undefined,
                description: undefined,
                code: '',
                position: undefined,
                type: 'fixed',
                applicable_for: 'customer',
                max_uses: undefined,
                max_uses_per_customer: undefined,
                percentage: undefined,
                amount: undefined,
                start_at: undefined,
                end_at: undefined,
                customers: [this.customer],
                // pivot: { uses: 0 },
                discard_the_following_coupons: false,
                discard_remaining_amount: true,
            }

            this.showCouponForm = true
        },
        // addDiscount() {
        //     this.pendingCoupon = {
        //         id: uniqid('new:'),
        //         name: undefined,
        //         description: undefined,
        //         code: undefined,
        //         position: undefined,
        //         // type: 'fixed',
        //         type: 'percentage',
        //         applicable_for: 'customer',
        //         max_uses: undefined,
        //         max_uses_per_customer: undefined,
        //         percentage: undefined,
        //         amount: undefined,
        //         start_at: undefined,
        //         end_at: undefined,
        //         pivot: { uses: 0 },
        //         discard_the_following_coupons: false,
        //         discard_remaining_amount: true,
        //     }
        //
        //     this.showCouponForm = true
        // },
        createCoupon(coupon) {
            this.memberStore.setFormCustomerCoupon(coupon)
        },
        updateCoupon(coupon) {
            this.memberStore.setFormCustomerCoupon(coupon)
        },
        deleteCoupon(coupon) {
            this.memberStore.deleteFormCustomerCoupon(coupon)
        },
        markCouponAsDeleted(coupon) {
            this.memberStore.markFormCustomerCouponAsDeleted(coupon)
        },
        unmarkCouponAsDeleted(coupon) {
            this.memberStore.unmarkFormCustomerCouponAsDeleted(coupon)
        },
        closeCouponForm() {
            setTimeout(() => {
                this.pendingCoupon = undefined;
            }, 300)
        },
    }
}
</script>

<style lang="sass" scoped>
    .customer-id-flex-col
        display: flex
        .switch
            padding-right: 20px
            min-height: 63px
        .input
            flex-grow: 1
    .switch-row
        margin-bottom: 1rem
    .coupons
        display: flex
        margin-bottom: 1rem
        flex-wrap: wrap
        gap: 1rem
</style>
